import {
  ErrorDefault,
  RequestDefault,
  ResponseDefault,
} from "../../shared/constant";
import globalUtils from "../../utils/globalUtils";
import distributorConstants from "../constants/distributorConstants";

const initialState: {
  distributors: any[];
  distributorCount: number;
  allDistributors: any[];
  distributorError: Boolean;
  distributorPending: Boolean;
  distributorFulfilled: Boolean;
  distributorListPending: Boolean;
} = {
  distributors: [],
  distributorCount: 0,
  allDistributors: [],
  distributorError: false,
  distributorPending: false,
  distributorFulfilled: false,
  distributorListPending: false,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case distributorConstants.GET_DISTRIBUTORS_REQUEST:
      return {
        ...state,
        distributorListPending: true,
      };
    case distributorConstants.GET_DISTRIBUTORS_SUCCESS:
      if (globalUtils.isResultsExistInObj(action.payload.data))
        return {
          ...state,
          distributorListPending: false,
          distributors: action.payload.data.results,
          distributorCount: action.payload.data.count,
        };
      return { ...state, allDistributors: action.payload.data };
    case distributorConstants.GET_DISTRIBUTORS_FAILURE:
      return {
        ...state,
        distributorListPending: false,
      };
    case distributorConstants.CREATE_DISTRIBUTOR_REQUEST:
    case distributorConstants.EDIT_DISTRIBUTOR_REQUEST:
      return {
        ...state,
        ...RequestDefault,
        distributorPending: true,
        distributorError: false,
        distributorFulfilled: false,
      };
    case distributorConstants.CREATE_DISTRIBUTOR_SUCCESS:
    case distributorConstants.EDIT_DISTRIBUTOR_SUCCESS:
      return {
        ...state,
        ...ResponseDefault,
        distributorPending: false,
        distributorError: false,
        distributorFulfilled: true,
      };
    case distributorConstants.CREATE_DISTRIBUTOR_FAILURE:
    case distributorConstants.EDIT_DISTRIBUTOR_FAILURE:
      return {
        ...state,
        ...ErrorDefault,
        distributorPending: false,
        distributorError: true,
        distributorFulfilled: false,
      };
    case distributorConstants.RESET_DISTRIBUTOR_REQUEST:
      return {
        ...state,
        distributorPending: false,
        distributorError: false,
        distributorFulfilled: false,
      };
    case distributorConstants.RESET_DISTRIBUTOR_LIST:
      return {
        ...state,
        distributors: [],
        distributorCount: 0,
        allDistributors: [],
      };
    default:
      return {
        ...state,
      };
  }
};
